var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.2692 0 0 6.2692 0 14C0 21.733 6.2692 28 14 28C21.733 28 28 21.733 28 14C28 6.2692 21.733 0 14 0ZM21.4665 14.9335L16.333 16.3335L14.933 21.467H13.0665L11.6665 16.3335L6.53296 14.9335V13.067L11.6665 11.667L13.0665 6.53352H14.933L16.333 11.667L21.4665 13.067V14.9335Z",
    fill: "#E9D3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrow);
export default __webpack_public_path__ + "static/media/scrow.558b2c656c2c9073645796284d737ab9.svg";
export { ForwardRef as ReactComponent };